(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .factory('grcPlanInitiativeEditModalService', ['$modal', '$rootScope', '$state', '$interval', 'notificationService', 'businessPlanningService', 'businessUnitService', 'historyCtxtService', 'modalService',
            function ($modal, $rootScope, $state, $interval, notificationService, businessPlanningService, businessUnitService, historyCtxtService, modalService) {
            return {
                showEditor: function (section, boxModel, args, index) {

                    var modalScope = $rootScope.$new();
                    var templatePath = '/app/shared/grc/businessPlanning/initiative/grcPlanInitiativeEdit.[Template].modal.tpl.html';

                    var activeIndex = index;
                    if (_.isUndefined(activeIndex)) activeIndex = 0;

                    //if a specific left tabmenu item should be initially selected
                    (index !== undefined) ? activeIndex = index : activeIndex = 0;

                    modalScope.ctrlCtxt = {
                        section: section,
                        isWizard: false,
                        isWizardDirty: false,
                        title: null,
                        activeIndex: activeIndex
                    };

                    modalScope.boxModel = _.cloneDeep(boxModel);

                    modalScope.sectionDependencies = {
                        name:              {LookupAttributes: true, FiscalYears: true },
                        category:          {LookupAttributes: true},
                        rationale:         {PlanCorporateObjectives: true, LookupAttributes: true, BusinessUnits: true},
                        'mitigated-risks': {},
                        'key-benefits':    {KeyBenefits: true},
                        resources:         {PlanBusinessUnits: true, BusinessUnits: true},
                        budget:            {},
                        other:             {}
                    };

                    modalScope.getTemplateUrl = function (templateId) {
                        return templatePath.replace('[Template]', templateId);
                    };

                    var modal = $modal({
                        scope: modalScope,
                        template: '/app/shared/grc/businessPlanning/initiative/grcPlanInitiativeEditModal.tpl.html',
                        placement: 'center',
                        backdrop: 'static',
                        keyboard: false,
                        prefixClass: 'initiative-modal modal'
                    });

                    init();

                    function getAvailableCorporateObjectives() {
                        businessPlanningService
                            .getAvailableCorporateObjectives(modalScope.boxModel.PlanInitiativeID)
                            .then(function (corpObjectives) {
                                modalScope.ctrlCtxt.allPlanCorporateObjectives = corpObjectives;
                            });
                    }

                    function getAvailableFiscalYears() {
                        businessPlanningService
                            .getAvailableFiscalYears(modalScope.boxModel.PlanInitiativeID)
                            .then(function (fiscalYears) {
                                modalScope.ctrlCtxt.allFiscalYears = fiscalYears;
                            });
                    }

                    function getAllLookupAttributeValues() {
                        businessPlanningService
                            .getLookupAttributeValues()
                            .then(function (attrValues) {
                                modalScope.ctrlCtxt.lookupAttributeValues = attrValues;
                            });
                    }

                    function getAllBusinessUnits() {
                        businessUnitService
                            .getAllBusinessUnits()
                            .then(function (businessUnits) {
                                modalScope.ctrlCtxt.availableBusinessUnits = businessUnits;
                            })
                    }

                    function getPlanBusinessUnits() {
                        businessPlanningService
                            .getAvailableBusinessUnits()
                            .then(function (planBusinessUnits) {
                                modalScope.ctrlCtxt.planBusinessUnits = planBusinessUnits;

                                modalScope.ctrlCtxt.availableOwnerBusinessUnits =
                                    getAvailableBusinessUnits(modalScope.boxModel.PlanBusinessUnitOwnerList);

                                modalScope.ctrlCtxt.availableInvolvedBusinessUnits =
                                    getAvailableBusinessUnits(modalScope.boxModel.PlanBusinessUnitInvolvedList);
                            });
                    }

                    function getKeyBenefits() {
                        businessPlanningService
                            .getAvailableMetricsForInitiative(modalScope.boxModel.PlanInitiativeID)
                            .then(function (availableKeyBenefits) {
                                modalScope.ctrlCtxt.availableKeyBenefits = availableKeyBenefits;

                                initKeyBenefits();
                            })
                    }

                    function getAvailableBusinessUnits(selectedBusinessUnits) {
                        return _.differenceWith(modalScope.ctrlCtxt.planBusinessUnits, selectedBusinessUnits, function (buUnit, selected) {
                            return buUnit.PlanBusinessUnitID === selected.PlanBusinessUnitID;
                        });
                    }

                    function updateTotalBudget() {
                        modalScope.ctrlCtxt.isTotalBudgetLoading = true;

                        businessPlanningService
                            .getPlanInitiativeWithBudget(modalScope.boxModel)
                            .then(function (initiativeWithBudget) {

                                modalScope.boxModel.TotalBudgetBeyondFiscalYear = initiativeWithBudget.TotalBudgetBeyondFiscalYear;
                                modalScope.boxModel.TotalBudgetForFiscalYear = initiativeWithBudget.TotalBudgetForFiscalYear;
                                modalScope.boxModel.TotalBudget = initiativeWithBudget.TotalBudget;
                            })
                            .finally(function () {
                                modalScope.ctrlCtxt.isTotalBudgetLoading = false;
                            });
                    }

                    function updateEstimatedBudget() {
                        modalScope.ctrlCtxt.isTotalBudgetLoading = true;

                        businessPlanningService
                            .getPlanInitiativeWithEstimatedBudget(modalScope.boxModel)
                            .then(function (initiativeWithEstimatedBudget) {
                                modalScope.boxModel.TotalEstimatedBudgetForFY =
                                    initiativeWithEstimatedBudget.ComputedBudget.TotalEstimatedBudgetForFY;

                                modalScope.boxModel.TotalEstimatedBudget =
                                    initiativeWithEstimatedBudget.ComputedBudget.TotalEstimatedBudget;
                            })
                            .finally(function () {
                                modalScope.ctrlCtxt.isTotalBudgetLoading = false;
                            });
                    }

                    function initKeyBenefits() {
                        modalScope.ctrlCtxt.selectedKeyBenefits = {};

                        _.each(modalScope.ctrlCtxt.availableKeyBenefits, function (availableKeyBenefit) {

                            modalScope.ctrlCtxt.selectedKeyBenefits[availableKeyBenefit.PlanCorporateMetricID] =
                                _.findIndex(modalScope.boxModel.PlanCorporateMetrics, {
                                    PlanCorporateMetricID: availableKeyBenefit.PlanCorporateMetricID
                                }) > -1;
                        })
                    }

                    function init() {
                        if (modalScope.sectionDependencies[modalScope.ctrlCtxt.section].PlanCorporateObjectives) {
                            getAvailableCorporateObjectives();
                        }
                        if (modalScope.sectionDependencies[modalScope.ctrlCtxt.section].FiscalYears) {
                            getAvailableFiscalYears();
                        }
                        if (modalScope.sectionDependencies[modalScope.ctrlCtxt.section].LookupAttributes) {
                            getAllLookupAttributeValues();
                        }
                        if (modalScope.sectionDependencies[modalScope.ctrlCtxt.section].BusinessUnits) {
                            getAllBusinessUnits();
                        }
                        if (modalScope.sectionDependencies[modalScope.ctrlCtxt.section].PlanBusinessUnits) {
                            getPlanBusinessUnits();
                        }
                        if (modalScope.sectionDependencies[modalScope.ctrlCtxt.section].KeyBenefits) {
                            getKeyBenefits();
                        }

                        if (_.isUndefined(modalScope.boxModel.NbInvolvedPermanents)) {
                            modalScope.boxModel.NbInvolvedPermanents = 0;
                        }

                        if (_.isUndefined(modalScope.boxModel.NbInvolvedConsultants)) {
                            modalScope.boxModel.NbInvolvedConsultants = 0;
                        }

                        if (_.isUndefined(modalScope.boxModel.OtherFixedFeeConsultingEngagement)) {
                            modalScope.boxModel.OtherFixedFeeConsultingEngagement = 0;
                        }

                        if (_.isUndefined(modalScope.boxModel.NbInvolvedITPermanents)) {
                            modalScope.boxModel.NbInvolvedITPermanents = 0;
                        }

                        if (_.isUndefined(modalScope.boxModel.NbInvolvedITConsultants)) {
                            modalScope.boxModel.NbInvolvedITConsultants = 0;
                        }

                        if (_.isUndefined(modalScope.boxModel.LicensingCost)) {
                            modalScope.boxModel.LicensingCost = 0;
                        }

                        modalScope.ctrlCtxt.initialCorporateObjective = modalScope.boxModel.PlanCorporateObjective;
                    }

                    // Select Owner
                    modalScope.selectOwner = function (person) {
                        modalScope.boxModel.Owner = person;
                        modalScope.boxModel.OwnerID = person.ItemPersonID;
                        modalScope.pageIsDirty();
                    };

                    // Select Owner Delegate
                    modalScope.selectOwnerDelegate = function (person) {
                        modalScope.boxModel.OwnerDelegate = person;
                        modalScope.boxModel.OwnerDelegateID = person.ItemPersonID;
                        modalScope.pageIsDirty();
                    };

                    // corpObjectiveChanged
                    modalScope.corpObjectiveChanged = function () {
                        modalScope.boxModel.PlanCorporateObjectiveID =
                            modalScope.boxModel.PlanCorporateObjective.PlanCorporateObjectiveID;

                        modalScope.pageIsDirty();
                    };

                    // endFiscalYearChanged
                    modalScope.endFiscalYearChanged = function () {
                        if (modalScope.boxModel.EndingFiscalYearID ===
                            modalScope.boxModel.EndingFiscalYear.FiscalYearID) return;

                        modalScope.boxModel.EndingFiscalYearID =
                            modalScope.boxModel.EndingFiscalYear.FiscalYearID;

                        modalScope.pageIsDirty();
                    };

                    // Init Key Contributors
                    modalScope.initKeyContributors = function () {
                        modalScope.selectedKeyContributors =
                            _.groupBy(modalScope.boxModel.KeyContributors, 'BusinessUnitID');
                    };

                    // Toggle Key Contributors selection
                    modalScope.toggleKeyContributor = function (businessUnit) {

                        if (modalScope.selectedKeyContributors[businessUnit.BusinessUnitID]) {

                            delete modalScope.selectedKeyContributors[businessUnit.BusinessUnitID];
                            _.remove(modalScope.boxModel.KeyContributors, {BusinessUnitID: businessUnit.BusinessUnitID});

                        } else {
                            modalScope.selectedKeyContributors[businessUnit.BusinessUnitID] = businessUnit;
                            modalScope.boxModel.KeyContributors.push(businessUnit);
                        }

                        modalScope.pageIsDirty();
                    };

                    // Get number of selected Key Contributors
                    modalScope.getNbSelectedContributors = function () {
                        return _.keys(modalScope.selectedKeyContributors).length;
                    };

                    // Init Stakeholders Impacted
                    modalScope.initStakeholdersImpacted = function () {
                        modalScope.selectedStakeholdersImpacted =
                            _.groupBy(modalScope.boxModel.BusinessUnitImpactedList, 'BusinessUnitID');
                    };

                    // Toggle Impacted Stakeholders selection
                    modalScope.toggleStakeholdersImpacted = function (businessUnit) {

                        if (modalScope.selectedStakeholdersImpacted[businessUnit.BusinessUnitID]) {

                            delete modalScope.selectedStakeholdersImpacted[businessUnit.BusinessUnitID];
                            _.remove(modalScope.boxModel.BusinessUnitImpactedList, {BusinessUnitID: businessUnit.BusinessUnitID});

                        } else {
                            modalScope.selectedStakeholdersImpacted[businessUnit.BusinessUnitID] = businessUnit;
                            modalScope.boxModel.BusinessUnitImpactedList.push(businessUnit);
                        }

                        modalScope.pageIsDirty();
                    };

                    // Get number of selected Stakeholders Impacted
                    modalScope.getNbSelectedStakeholders = function () {
                        return _.keys(modalScope.selectedStakeholdersImpacted).length +
                            _.keys(modalScope.selectedOtherStakeholders).length;
                    };

                    // Init Selected Change Types
                    modalScope.initSelectedChangeTypes = function () {
                        if (_.isUndefined(modalScope.boxModel.ChangeTypeList)) modalScope.boxModel.ChangeTypeList = [];

                        modalScope.selectedChangeTypes =
                            _.groupBy(modalScope.boxModel.ChangeTypeList, 'LookupAttributeValueID');
                    };

                    // Toggle Change Types selection
                    modalScope.toggleChangeType = function (changeType) {

                        if (modalScope.selectedChangeTypes[changeType.LookupAttributeValueID]) {

                            delete modalScope.selectedChangeTypes[changeType.LookupAttributeValueID];
                            _.remove(modalScope.boxModel.ChangeTypeList, {LookupAttributeValueID: changeType.LookupAttributeValueID});

                        } else {
                            modalScope.selectedChangeTypes[changeType.LookupAttributeValueID] = changeType;
                            modalScope.boxModel.ChangeTypeList.push(changeType);
                        }

                        modalScope.pageIsDirty();
                    };

                    // Init Selected Other Stakeholders
                    modalScope.initSelectedOtherStakeholders = function () {
                        if (_.isUndefined(modalScope.boxModel.OtherStakeholderImpactedList)) {
                            modalScope.boxModel.OtherStakeholderImpactedList = [];
                        }

                        modalScope.selectedOtherStakeholders =
                            _.groupBy(modalScope.boxModel.OtherStakeholderImpactedList, 'LookupAttributeValueID');
                    };

                    // Toggle Other Stakeholders selection
                    modalScope.toggleOtherStakeholders = function (otherStakeholder) {

                        if (modalScope.selectedOtherStakeholders[otherStakeholder.LookupAttributeValueID]) {

                            delete modalScope.selectedOtherStakeholders[otherStakeholder.LookupAttributeValueID];
                            _.remove(modalScope.boxModel.OtherStakeholderImpactedList, {
                                LookupAttributeValueID: otherStakeholder.LookupAttributeValueID
                            });

                        } else {
                            modalScope.selectedOtherStakeholders[otherStakeholder.LookupAttributeValueID] = otherStakeholder;
                            modalScope.boxModel.OtherStakeholderImpactedList.push(otherStakeholder);
                        }

                        modalScope.pageIsDirty();
                    };

                    // Required SMEs
                    modalScope.addRequiredSME = function (person) {
                        if (_.isUndefined(modalScope.boxModel.RequiredSMEList)) modalScope.boxModel.RequiredSMEList = [];
                        modalScope.boxModel.RequiredSMEList.push(person);
                        modalScope.pageIsDirty();
                    };
                    modalScope.removeRequiredSME = function (person) {
                        modalScope.boxModel.RequiredSMEList = _.reject(modalScope.boxModel.RequiredSMEList, {
                            ItemPersonID: person.ItemPersonID
                        });
                        modalScope.pageIsDirty();
                    };

                    // Hide Modal
                    modalScope.hideModal = function () {
                        _.set(modalScope, 'modalStyle.visibility', 'hidden');
                    };

                    // Show Modal
                    modalScope.showModal = function () {
                        _.set(modalScope, 'modalStyle.visibility', 'visible');

                        /**
                         * Patch to fix issue with angular-strap.
                         * When second modal closes, it removes the 'modal-open' class
                         * from the body element, changing the behavior of the first modal.
                         */
                        var bodyEl = document.querySelector('body');
                        var interval = $interval(function () {
                            if (!bodyEl.classList.contains('modal-open')) {
                                bodyEl.classList.add('modal-open');
                                $interval.cancel(interval);
                            }
                        }, 10, false);
                    };

                    // Add Risk
                    modalScope.addRisk = function () {
                        modalScope.hideModal();

                        var onModalHide = function () {
                            modalScope.showModal();
                        };

                        var modal = modalService.displayTemplateModal(
                            'Select relevant risks available to your department',
                            require('./grcPlanInitiativeRiskSelector.modal.tpl.html'),
                            {
                                ngStyle: {'min-height': 'auto', width: '60vw'},
                                initiative: modalScope.boxModel,
                                selectedRisks: modalScope.boxModel.KeyRisksMitigated,
                                onRiskSelected: function (selectedRisk) {
                                    modalScope.boxModel.KeyRisksMitigated =
                                        modalScope.boxModel.KeyRisksMitigated || [];

                                    modalScope.boxModel.KeyRisksMitigated.push(selectedRisk);
                                    modalScope.pageIsDirty();

                                    modal.hide();
                                    onModalHide();
                                }
                            },
                            false,
                            true,
                            onModalHide
                        );
                    };

                    // Has Planning-Only Edit
                    modalScope.hasPlanningOnlyEdit = function () {
                        return modalScope.boxModel.HasPlanInitiative_PlanningOnlyEdit;
                    };

                    // Remove Mitigated Risk
                    modalScope.removeMitigatedRisk = function (risk) {
                        _.remove(modalScope.boxModel.KeyRisksMitigated, function (vRisk) {
                            return vRisk.RiskID === risk.RiskID;
                        });
                        modalScope.pageIsDirty();
                    };

                    // Budget Field Changed
                    modalScope.budgetFieldChanged = function () {
                        modalScope.pageIsDirty();

                        updateTotalBudget();
                    };

                    // Estimated Budget Field Changed
                    modalScope.estimatedBudgetFieldChanged = function () {
                        modalScope.pageIsDirty();

                        updateEstimatedBudget();
                    };

                    // Get number of people
                    modalScope.getNbAsArray = function (nbUsers) {
                        if (_.isNil(nbUsers)) return [];

                        // Max 10 users to display
                        if (nbUsers > 10) {
                            nbUsers = 10;
                        }

                        return new Array(_.round(nbUsers));
                    };

                    // Update Key Benefits
                    modalScope.updateKeyBenefits = function (keyBenefit) {
                        var selected = modalScope.ctrlCtxt.selectedKeyBenefits[keyBenefit.PlanCorporateMetricID];

                        if (selected) {
                            modalScope.boxModel.PlanCorporateMetrics.push(keyBenefit);
                        } else {
                            _.remove(modalScope.boxModel.PlanCorporateMetrics, {
                                PlanCorporateMetricID: keyBenefit.PlanCorporateMetricID
                            });
                        }
                        modalScope.pageIsDirty();
                    };

                    // Toggle Key Benefit
                    modalScope.toggleKeyBenefit = function (keyBenefit) {
                        modalScope.ctrlCtxt.selectedKeyBenefits[keyBenefit.PlanCorporateMetricID] =
                            !modalScope.ctrlCtxt.selectedKeyBenefits[keyBenefit.PlanCorporateMetricID];

                        modalScope.updateKeyBenefits(keyBenefit);
                    };

                    // On Cancel
                    modalScope.onCancel = function () {
                        if (modalScope.ctrlCtxt.isWizardDirty) {
                            closeModal();
                            historyCtxtService.reload();
                        } else {
                            closeModal();
                        }
                    };

                    // On Save and Continue
                    modalScope.onSaveAndContinue = function () {
                        if (modalScope.ctrlCtxt.isPageDirty) {
                            modalScope.ctrlCtxt.isWizardDirty = true;
                            updateInitiative()
                                .then(function () {
                                    modalScope.ctrlCtxt.initialCorporateObjective = modalScope.boxModel.PlanCorporateObjective;
                                    modalScope.ctrlCtxt.activeIndex++;
                                });
                        } else {
                            modalScope.ctrlCtxt.activeIndex++;
                        }
                    };

                    // On Save and Close
                    modalScope.onSaveAndClose = function (form) {
                        if (form.$invalid) return;

                        if (modalScope.ctrlCtxt.isPageDirty || modalScope.ctrlCtxt.isWizardDirty) {
                            updateInitiative()
                                .then(function () {
                                    closeModal();

                                    historyCtxtService.reload();
                                });
                        } else {
                            closeModal();
                        }
                    };

                    // On Previous (wizard)
                    modalScope.onPrevious = function () {
                        modalScope.ctrlCtxt.activeIndex--;
                    };

                    // Page is Dirty
                    modalScope.pageIsDirty = function () {
                        modalScope.ctrlCtxt.isPageDirty = true;
                    };

                    // Page is Not Dirty
                    modalScope.pageIsNotDirty = function () {
                        modalScope.ctrlCtxt.isPageDirty = false;
                    };

                    function closeModal() {
                        modal.hide();

                        if (args.onModalClose) args.onModalClose();

                        modalScope.$destroy();
                    }

                    function updateInitiative() {
                        modalScope.ctrlCtxt.isLoading = true;
                        modalScope.ctrlCtxt.showSubmitError = false;

                        return businessPlanningService
                            .createOrUpdateInitiative(modalScope.boxModel)
                            .then(function (updatedInitiative) {

                                modalScope.boxModel = updatedInitiative;

                                notificationService.notify('Your changes have been saved', {
                                    preventScroll: true
                                });
                                modalScope.pageIsNotDirty();
                                return updatedInitiative;
                            })
                            .finally(function () {
                                modalScope.ctrlCtxt.isLoading = false;
                            });
                    }
                }
            };

        }]);
})();
